<a routerLink="">
  <mat-icon>arrow_back</mat-icon>
</a>
<div class="mat-typography">
  <div class="main-setting-row">
    <label for="scope" class="main-item-width">Played on :</label>
    <div id="scope" style="width: 150px;">
      <mat-select [(value)]="settings.playScope" (selectionChange)="onChanged()">
        @for (s of playScopes; track s) {
        <mat-option [value]="s">{{s}}</mat-option>
        }
      </mat-select>
    </div>
    <label for="queried" class="main-item-width">Queried on :</label>
    <div id="queried">
      <mat-checkbox class="main-item-width" [(ngModel)]="settings.queryName" (change)="onChanged()">Name</mat-checkbox>
      <mat-checkbox class="main-item-width" [(ngModel)]="settings.queryCapital"
        (change)="onChanged()">Capital</mat-checkbox>
      <mat-checkbox class="main-item-width" [(ngModel)]="settings.queryLocation"
        (change)="onChanged()">Location</mat-checkbox>
      <mat-checkbox class="main-item-width" [(ngModel)]="settings.queryFlag" (change)="onChanged()">Flag</mat-checkbox>
    </div>
    <label for="given" class="main-item-width">Given :</label>
    <div id="given">
      <mat-checkbox class="main-item-width" [(ngModel)]="settings.showName" (change)="onChanged()">Name</mat-checkbox>
      <mat-checkbox class="main-item-width" [(ngModel)]="settings.showCapital"
        (change)="onChanged()">Capital</mat-checkbox>
      <mat-checkbox class="main-item-width" [(ngModel)]="settings.showLocation"
        (change)="onChanged()">Location</mat-checkbox>
      <mat-checkbox class="main-item-width" [(ngModel)]="settings.showFlag" (change)="onChanged()">Flag</mat-checkbox>
    </div>
    <mat-checkbox class="main-item-width" [(ngModel)]="settings.showNext" (change)="onChanged()">Next</mat-checkbox>
  </div>
</div>
<mat-divider></mat-divider>
@if (stats) {
<div class="mat-typography">
  <h4 class="centered">Played {{stats.nbGames}} game{{stats.nbGames &gt; 1 ? 's' : ''}}</h4>
  <h4 class="centered">
    Last Game Time : {{getLongTime(stats.gamesTiming.last)}}
    &nbsp; - &nbsp; Average Time : {{getLongTime(stats.gamesTiming.average)}}
    &nbsp; - &nbsp; Best Time : {{getLongTime(stats.gamesTiming.min)}}
    &nbsp; - &nbsp; Worst Time : {{getLongTime(stats.gamesTiming.max)}}
  </h4>
  <mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="country">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Country</mat-header-cell>
      <mat-cell *matCellDef="let element">{{element.country}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="last">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Last Game</mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{getShortTime(element.last)}}&nbsp;&nbsp;&nbsp;
        <span [style.color]="getLastGameColor(element)">{{getLastGameTrend(element)}}</span></mat-cell>
    </ng-container>
    <ng-container matColumnDef="average">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Average</mat-header-cell>
      <mat-cell *matCellDef="let element">{{getShortTime(element.average)}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="min">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Minimum</mat-header-cell>
      <mat-cell *matCellDef="let element">{{getShortTime(element.min)}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="max">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Maximum</mat-header-cell>
      <mat-cell *matCellDef="let element">{{getShortTime(element.max)}}</mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="['country', 'last', 'average', 'min', 'max']"></mat-header-row>
    <mat-row *matRowDef="let row; columns: ['country', 'last', 'average', 'min', 'max'];"></mat-row>
  </mat-table>
</div>
}
@if (!stats) {
<div class="mat-typography centered">
  No Data
</div>
}
